module.exports = __webpack_public_path__ + "img/preservation_img.518836d4.png";